<template>
    <section class="recaptcha-page flow__panel">
        <div class="recaptcha-page__main">
            <h2 class="recaptcha-page__title">
                {{ this.$scheme.resources.app.introText }}
            </h2>
            <app-sponsorship class="recaptcha-page__sponsorship" />
            <p class="recaptcha-page__text">
                Just need to check that you're human.
            </p>
            <hh-form class="recaptcha-page__form">
                <hh-form-group>
                    <hh-recaptcha-invisible ref="invisibleRecaptcha"
                                            class="recaptcha-page__form__catch"
                                            @verified="onVerified"
                                            @already-verified="onVerified" />
                </hh-form-group>
                <span class="recaptcha-page__log-in">
                    <router-link class="recaptcha-page__log-in__link" :to="{ name: 'LogIn' }">Log In</router-link>
                </span>
                <hh-btn type="cta"
                        class="recaptcha-page__form__next"
                        icon-class="fas fa-chevron-circle-right"
                        icon-location="post"
                        text="Continue"
                        @click="onNextClick" />
            </hh-form>
        </div>
    </section>
</template>

<script>

import Vuex from 'vuex'

import Property from '../models/property'

import AnalyticsPage from './analytics-page'

import AppSponsorship from '../components/app-core/app-sponsorship'

export default {

    props: {
        redirect: {
            type: Object,
            default: null,
        },
    },

    mixins: [
        AnalyticsPage,
    ],

    data() {
        return {
            postcode: '',
            captchaVerified: false,
        }
    },

    computed: {

        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Property}
             */
            property: stateStore => Property.ensure(stateStore.property),

            /**
             * @param {VuexState} stateStore
             * @returns {boolean}
             */
            hasProject: stateStore => stateStore.improvements.currentProject && stateStore.improvements.currentProject.initialised,
        }),
    },

    beforeMount() {
        if (!this.property)
            this.$router.push({ name: 'Welcome' })

    },

    methods: {

        onNextClick() {
            if (this.captchaVerified)
                this._loadApp()
            else if (this.$refs.invisibleRecaptcha && this.$refs.invisibleRecaptcha.execute)
                this.$refs.invisibleRecaptcha.execute()
        },

        onVerified(isVerified = true) {
            this.captchaVerified = isVerified
            if (isVerified) this._loadApp()
        },

        _loadApp() {
            if (!this.captchaVerified) return

            if (this.redirect) {
                this.$router.replace(this.redirect.path)
            } else if (this.hasProject) {
                this.$router.push({ name: 'PlanBuilder' })
            } else {
                this.$router.push({
                    name: 'MyHome',
                    query: { id: this.property.id },
                })
            }
        },
    },

    components: {
        AppSponsorship,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.recaptcha-page {
    @include wizard-page;
    @include recaptcha-or-login;
}

</style>
